import { ApiOutlined } from "@ant-design/icons";

export default function PlannedTrialConnections() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <ApiOutlined className="text-[40px] text-[#D1D5DB] mb-4" />
      <h2 className="text-[18px] font-semibold text-[#1F2933] mb-2">
        Data Connections
      </h2>
      <p className="text-[14px] text-[#9CA3AF] max-w-md">
        Connect EDC, CTMS, lab, and other data sources once this trial moves
        into execution.
      </p>
    </div>
  );
}
